"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _currency = require("@/api/currency");
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      input: '',
      select: '',
      calc: '',
      dialogVisible: false,
      list: [],
      listLoading: true,
      total: 0,
      pageNo: 1,
      pageSize: 10,
      currencyList: [],
      btnLoading: false,
      baseCurrency: '',
      form: {
        conversionRates: null
      },
      usd: null,
      rate: 0
    };
  },
  created: function created() {},
  computed: {
    value: function value() {
      try {
        if (!this.form.conversionRates) return 0;
        return this.getMoney(this.form.conversionRates, true);
      } catch (error) {
        return 0;
      }
    },
    value2: function value2() {
      try {
        return this.getMoney(this.rate);
      } catch (error) {
        return 0;
      }
    }
  },
  mounted: function mounted() {
    this.getList();
    this.queryCurrencyRatesToday();
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    getMoney: function getMoney(rate, f) {
      if (f) {
        // 转人名币

        return (Math.round(1 / rate * 10000) / 10000).toFixed(4);
      } else {
        // 转美元
        return (Math.round(rate * 10000) / 10000).toFixed(4);
      }
    },
    queryCurrencyRatesToday: function () {
      var _queryCurrencyRatesToday2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _currency.queryCurrencyRatesToday)();
            case 1:
              res = _context.v;
              this.rate = res.data.conversionRates;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function queryCurrencyRatesToday() {
        return _queryCurrencyRatesToday2.apply(this, arguments);
      }
      return queryCurrencyRatesToday;
    }(),
    date: function date(str) {
      try {
        var year = (0, _moment.default)(str).year();
        var month = (0, _moment.default)(str).month() + 1;
        return "".concat(year, "\u5E74").concat(month, "\u6708 \u6C47\u7387");
      } catch (error) {
        return str;
      }
    },
    time: function time(row) {
      try {
        var s = row.startDate.split(" ")[0].replace(/-/g, '/');
        var e = row.endDate.split(" ")[0].replace(/-/g, '/');
        return "".concat(s, "-").concat(e);
      } catch (error) {
        return '';
      }
    },
    text: function text(code) {
      try {
        if (code == 0) return {
          label: '进行中',
          color: '#528591'
        };
        if (code == 1) return {
          label: '结束',
          color: '#b9b9b9'
        };
        if (code == 2) return {
          label: '待开始',
          color: '#ef8a15'
        };
        return {
          label: '待开始',
          color: '#ef8a15'
        };
      } catch (error) {
        return {};
      }
    },
    eidt: function eidt(row) {
      this.form = row;
      this.dialogVisible = true;
    }
  }, "queryCurrencyRatesToday", function () {
    var _queryCurrencyRatesToday3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
      var res;
      return (0, _regenerator2.default)().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return (0, _currency.queryCurrencyRatesToday)();
          case 1:
            res = _context2.v;
            this.rate = res.data.data.conversionRates;
            console.log(res, 'res');
          case 2:
            return _context2.a(2);
        }
      }, _callee2, this);
    }));
    function queryCurrencyRatesToday() {
      return _queryCurrencyRatesToday3.apply(this, arguments);
    }
    return queryCurrencyRatesToday;
  }()), "getCurrencyList", function getCurrencyList() {
    var _this = this;
    (0, _currency.currencyListUrl)().then(function (data) {
      var res = data.data;
      if (res.errno == 0) {
        _this.currencyList = res.data;
        if (JSON.parse(sessionStorage.getItem('rate'))) {
          _this.select = JSON.parse(sessionStorage.getItem('rate')).select;
        } else {
          _this.select = _this.currencyList.filter(function (item) {
            return item.currency !== _this.baseCurrency;
          })[0].currency;
        }
        _this.getList();
      }
    });
  }), "getRate", function getRate() {
    (0, _currency.currencyRatesL)().then(function (data) {
      var res = data.data;
      if (res.errno == 0) {
        console.log(res, 'res');
      }
    });
  }), "calculation", function calculation() {
    var _this2 = this;
    if (this.input) {
      (0, _currency.currencyRatesTodayUrl)().then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this2.calc = JSON.parse(res.data.conversionRates)[_this2.select] * +_this2.input;
          sessionStorage.setItem('rate', JSON.stringify({
            calc: _this2.calc,
            input: _this2.input,
            select: _this2.select
          }));
        }
      });
    } else {
      this.calc = '';
      sessionStorage.setItem('rate', JSON.stringify({
        calc: this.calc,
        input: this.input,
        select: this.select
      }));
    }
  }), "getList", function getList() {
    var _this3 = this;
    this.listLoading = true;
    var params = {
      pageNo: this.pageNo,
      pageSize: this.pageSize
    };
    (0, _currency.currencyRatesL)(params).then(function (data) {
      var res = data.data;
      if (res.errno == 0) {
        _this3.listLoading = false;
        _this3.list = res.data.list;
        _this3.total = res.data.total;
      }
    }).finally(function () {
      _this3.listLoading = false;
    });
  }), "closeDialog", function closeDialog(val) {
    this.dialogVisible = false;
    if (val) {
      this.getList();
    }
  }), "updateRate", function updateRate() {
    var _this4 = this;
    this.btnLoading = true;
    (0, _currency.currencyRatesLUpdate)((0, _objectSpread2.default)({}, this.form)).then(function (data) {
      _this4.btnLoading = false;
      var res = data.data;
      if (res.errno == 0) {
        _this4.closeDialog(true);
        _this4.getList();
        _this4.queryCurrencyRatesToday();
      }
    }).catch(function () {
      _this4.btnLoading = false;
    });
  })
};